module.exports = __webpack_public_path__ + "media/images/flags/ua-f9cbc20b1a8b52e25c92bad309fd6f47.svg";